import React from 'react';
import PropTypes from 'prop-types';

const DrivingLicense = ({ fill, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.28625 9C8.1495 9 8.78625 8.36325 8.78625 7.5C8.78625 6.63675 8.1495 6 7.28625 6C6.423 6 5.78625 6.63675 5.78625 7.5C5.78625 8.36325 6.42225 9 7.28625 9Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M15 3H3C2.17275 3 1.5 3.63075 1.5 4.40625V13.5938C1.5 14.3693 2.17275 15 3 15H15C15.8273 15 16.5 14.3693 16.5 13.5938V4.40625C16.5 3.63075 15.8273 3 15 3ZM15 13.5L3 13.4918V4.5L15 4.50825V13.5Z"
      fill={fill || '#6B6C7B'}
    />
    <path
      d="M10.5 6.75H13.5V8.25H10.5V6.75ZM11.25 9.75H13.5V11.25H11.25V9.75ZM10.0725 11.652C10.0725 10.6215 8.8155 9.5625 7.28625 9.5625C5.757 9.5625 4.5 10.6215 4.5 11.652V12H10.0725V11.652Z"
      fill={fill || '#6B6C7B'}
    />
  </svg>
);

DrivingLicense.propTypes = {
  fill: PropTypes.string,
};

export default DrivingLicense;
